import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { BonusHistory, OCC_ENDPOINTS, OccBonusHistorySearchParams } from '@my-account/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BonusHistoryApiService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadBonusHistory(userId: string, params?: OccBonusHistorySearchParams): Observable<BonusHistory> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.bonusHistory, {
      urlParams: { userId },
      queryParams: params,
    });

    return this.http.get<BonusHistory>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.bonusHistory),
    });
  }
}
